<script setup>
import { ref } from "vue";
import { useToast } from "primevue/usetoast";

const toast = useToast();

const visible = ref(false); // Show/Hide dialog
const editingIndex = ref(null); // Track editing row
const form = ref({ unionMembership: "", healthInfo: "", notes: "" });
const records = ref([]);

// Open dialog for new entry
const openForm = () => {
  editingIndex.value = null;
  form.value = { unionMembership: "", healthInfo: "", notes: "" };
  visible.value = true;
};

// Save or update the record
const saveRecord = () => {
  if (editingIndex.value !== null) {
    records.value[editingIndex.value] = { ...form.value };
    toast.add({ severity: "success", summary: "Updated", detail: "Record updated", life: 2000 });
  } else {
    records.value.push({ ...form.value });
    toast.add({ severity: "success", summary: "Added", detail: "Record added", life: 2000 });
  }
  visible.value = false;
};

// Edit an existing record
const editRecord = (rowData, index) => {
  form.value = { ...rowData };
  editingIndex.value = index;
  visible.value = true;
};

// Delete a record
const deleteRecord = (index) => {
  records.value.splice(index, 1);
  toast.add({ severity: "warn", summary: "Deleted", detail: "Record removed", life: 2000 });
};
</script>

<template>
  <div class="p-5">
  <Toast />

    <Button label="Add Information" icon="pi pi-plus" @click="openForm" class="p-button-success mb-3" />

    <!-- Data Table -->
    <DataTable :value="records" class="p-datatable p-component">
      <Column field="unionMembership" header="Union Membership"></Column>
      <Column field="healthInfo" header="Health Information"></Column>
      <Column field="notes" header="Notes/Comments"></Column>
      <Column header="Actions">
        <template #body="{ data, index }">
          <Button icon="pi pi-pencil" class="p-button-text p-button-sm" @click="editRecord(data, index)" />
          <Button icon="pi pi-trash" class="p-button-text p-button-sm p-button-danger" @click="deleteRecord(index)" />
        </template>
      </Column>
    </DataTable>

    <!-- Dialog Form -->
    <Dialog v-model:visible="visible" modal header="Add Information" :style="{ width: '400px' }">
      <div class="flex flex-col gap-3">
        <div>
          <label class="block text-sm font-medium">Union Membership</label>
          <InputText v-model="form.unionMembership" class="w-full p-inputtext" />
        </div>
        <div>
          <label class="block text-sm font-medium">Health Information</label>
          <Textarea v-model="form.healthInfo" class="w-full p-inputtext" rows="3" />
        </div>
        <div>
          <label class="block text-sm font-medium">Notes/Comments</label>
          <Textarea v-model="form.notes" class="w-full p-inputtext" rows="3" />
        </div>
      </div>

      <template #footer>
        <Button label="Cancel" icon="pi pi-times" class="p-button-text" @click="visible = false" />
        <Button label="Save" icon="pi pi-check" class="p-button-primary" @click="saveRecord" />
      </template>
    </Dialog>
  </div>
</template>

<style scoped>
.p-button-sm {
  margin-right: 5px;
}
</style>
